module.exports = __webpack_public_path__ + "static/media/tna-adjust.3887a264.mp4";